"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOnboardingModelProvider = exports.useOnboardingModelContext = exports.OnboardingModelProvider = exports.HintType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const bridge_1 = require("@completeanatomy/bridge");
const noop_1 = __importDefault(require("lodash/noop"));
var HintType;
(function (HintType) {
    HintType[HintType["Pan"] = 0] = "Pan";
    HintType[HintType["Rotate"] = 1] = "Rotate";
    HintType[HintType["Zoom"] = 2] = "Zoom";
    HintType[HintType["Home"] = 3] = "Home";
})(HintType || (exports.HintType = HintType = {}));
const defaultValue = {
    pages: [],
    page: 0,
    nextPage: noop_1.default,
};
const OnboardingModelContext = (0, react_1.createContext)(defaultValue);
function OnboardingModelProvider({ pages, children, }) {
    const [page, setPage] = (0, react_1.useState)(0);
    const bridge = (0, bridge_1.useBridge)();
    const nextPage = (0, react_1.useCallback)(() => page + 1 >= pages.length
        ? bridge === null || bridge === void 0 ? void 0 : bridge.setModelOnboardingShown()
        : setPage(page + 1), [page, pages.length, bridge]);
    const store = (0, react_1.useMemo)(() => ({
        pages,
        page,
        nextPage,
    }), [pages, page, nextPage]);
    return ((0, jsx_runtime_1.jsx)(OnboardingModelContext.Provider, { value: store, children: children }));
}
exports.OnboardingModelProvider = OnboardingModelProvider;
const useOnboardingModelContext = () => (0, react_1.useContext)(OnboardingModelContext);
exports.useOnboardingModelContext = useOnboardingModelContext;
const withOnboardingModelProvider = ({ pages }) => (WrappedComponent) => (props) => ((0, jsx_runtime_1.jsx)(OnboardingModelProvider, { pages: pages, children: (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, props, { children: props.children })) }));
exports.withOnboardingModelProvider = withOnboardingModelProvider;
